// extracted by mini-css-extract-plugin
export var alignCenter = "_bt-d";
export var bannerShown = "_bt-6";
export var buttonContent = "_bt-0";
export var cardList = "_bt-1";
export var centerContent = "_bt-2";
export var chevron = "_bt-3";
export var closePanelButton = "_bt-k";
export var conversationContextContainer = "_bt-l";
export var conversationDetailContainer = "_bt-4";
export var detailWrapper = "_bt-7";
export var dropdownButton = "_bt-e";
export var dropdownTitle = "_bt-9";
export var fullHeight = "_bt-5";
export var hidden = "_bt-a";
export var icon = "_bt-b";
export var mergeSuggestionWrapper = "_bt-m";
export var panel = "_bt-i";
export var portalButtonsWrapper = "_bt-c";
export var right = "_bt-j";
export var tableSummaryContainer = "_bt-8";
export var tableSummaryHeader = "_bt-g";
export var threeDotsButton = "_bt-f";
export var wide = "_bt-h";